/*
 * @Author: cjh
 * @Date: 2022-05-11 17:33:55
 * @LastEditTime: 2022-05-11 16:57:04
 * @LastEditors: Please set LastEditors
 * @Description: 间歇激活usessionid
 * @FilePath: utils-khfw\heartbeat.js
 */
import api from "@/utils-khfw/crosRequestHandler.js";
import { MessageBox } from "element-ui";
export default {
  timer: null,
  loseCount: 0, //心跳失败三次后 提示用户重新登录
  async send() {
    const usessionid = sessionStorage.getItem("usessionid");
    const platformVersion = sessionStorage.getItem("platformVersion");

    if (platformVersion === "6") {
      const { result } = await api({
        method: "post",
        data: {
          intername: "aamif.url",
          requestUri: `/aamif/rest/account/heartbeat/${usessionid}`,
          requestType: "get",
        },
      });
      if (result != "000000") {
        this.loseCount += 1;
      } else {
        this.loseCount = 0;
      }
    } else {
      const { code } = await api({
        method: "post",
        data: {
          intername: "aamif.url",
          requestUri: `/account/api/account/heartbeat?usession_id=${usessionid}`,
          requestType: "get",
        },
      });
      if (code != "000000") {
        this.loseCount += 1;
      } else {
        this.loseCount = 0;
      }
    }
    if (this.loseCount >= 3) {
      MessageBox.alert("登录状态已失效，请重新登录", "提示", {
        confirmButtonText: "确定",
        center: true,
        showClose: false,
        customClass: "chat-messagebox",
      }).then(() => {
        var domain = sessionStorage.getItem("domain");
        window.open(
          `${domain}/index.php?r=portal/user/logout&service=${domain}/index.php?r=portal/supervise/login&site=yn`,
          "_self"
        );
        var storage = window.sessionStorage;
        storage.clear();
        this.$message({
          type: 'success',
          message: '退出成功'
        }); 
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '退出失败'
        });          
      });
    }
  },
  // 十分钟跳一次 不立即执行
  start() {
    console.log("--->开始心跳");
    this.timer && clearTimeout(this.timer);
    const _scope = this;
    const fn = function () {
      _scope.timer = setTimeout(function () {
        _scope.send();
        fn();
      }, 1000 * 60 * 10);
    };
    fn();
  },
};
